import React from "react";

import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";

import useForm from "commons/hooks/useForm";

import { ObjectPropertyType } from "commons/types/validation";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import Paper from "commons/ui/Paper";

import { notEmptyValidator } from "commons/utils/validate";

import { useAuthContext } from "context/auth";

import useUserApi from "hooks/api/public/useUserApi";

function Login() {
    const navigate = useNavigate();

    const schema: ObjectPropertyType = React.useMemo(
        (): ObjectPropertyType => ({
            type: "object",
            validators: [],
            properties: {
                username: {
                    type: "simple",
                    validators: [notEmptyValidator],
                },
                password: {
                    type: "simple",
                    validators: [notEmptyValidator],
                },
            },
        }),
        []
    );

    const { setValue, form, isValid } = useForm(schema, { username: "", password: "" });

    const { login } = useUserApi();

    const { setAccessToken } = useAuthContext();

    const onButtonClick = React.useCallback(() => {
        const [apiCall] = login({ username: form.username, password: form.password });

        apiCall.then((response) => {
            setAccessToken(response.token);

            navigate("/");
        });
    }, [navigate, login, setAccessToken, form]);

    return (
        <GridColumn className="login-cointainer">
            <>
                <h1 className={"login-title"}>{"LOGIN"}</h1>

                <Paper className={"login-paper"}>
                    <GridColumn>
                        <GridRow>
                            <GridItem className={"col-xs-12-12 login-input"}>
                                <InputText
                                    label={"Username"}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                        setValue("username", event.target.value)
                                    }
                                    value={form.username}
                                />
                            </GridItem>

                            <GridItem className={"col-xs-12-12 login-input"}>
                                <InputText
                                    label={"Password"}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                        setValue("password", event.target.value)
                                    }
                                    value={form.password}
                                    type={"password"}
                                />
                            </GridItem>

                            <GridItem className={"login-button"}>
                                <Button
                                    variant={"contained"}
                                    onClick={onButtonClick}
                                    disabled={!isValid}
                                >
                                    {"LOGIN"}
                                </Button>
                            </GridItem>
                        </GridRow>
                    </GridColumn>
                </Paper>
            </>
        </GridColumn>
    );
}

export default Login;
